import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { CartState, OrderDetails } from "../../../stores/slices/cartSlice";
import { OrderItem } from "./OrderItem";

export const OrderItemList: FunctionComponent<{
  cart?: CartState | OrderDetails;
}> = ({ cart }) => {
  const { t } = useTranslation();
  return (
    <>
      {!cart?.orderItemList.length && (
        <p className="pb-8">{t("cart.noOrders")}</p>
      )}
      {cart?.orderItemList.map((orderItem, index) => (
        <OrderItem
          key={orderItem.itemId}
          last={index === cart.orderItemList.length - 1}
          orderItem={orderItem}
        />
      ))}
    </>
  );
};
